<template>
  <callback-status variant="expired" />
</template>

<script>
import CallbackStatus from './CallbackStatus.vue'

export default {
  components: { CallbackStatus },
}
</script>
